
import loaderimg from "../../assets/images/loader.gif";

const ListLoader = () => {
  return (
    <div className="d-flex justify-content-center w-100" ><span className="icon-40"><img
      src={loaderimg}
      alt=""
    /></span></div>
  )
};

export default ListLoader;
